// denim&archives theme. Every page works without this file; it adds the drawer, saved pieces and small conveniences.
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
  };
  const routes = (window.dna && window.dna.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mobile menu
  const menuBtn = $('.nav__menu');
  const menu = $('#menu');
  menuBtn?.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', String(open));
  });

  // Originals films: load and play only while on screen
  const films = $$('.films video, .film-tile video');
  if (!reduce && 'IntersectionObserver' in window && films.length) {
    const io = new IntersectionObserver((entries) => {
      for (const { target: v, isIntersecting } of entries) {
        if (isIntersecting) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else { v.pause(); }
      }
    }, { threshold: 0.25 });
    films.forEach((v) => io.observe(v));
  }

  // Views: 3 / 4 / 6 per row, remembered in this browser
  const applyCols = (cols) => {
    if (!['3', '4', '6'].includes(cols)) cols = '4';
    $$('[data-grid]').forEach((g) => { g.dataset.cols = cols; });
    $$('.views button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cols === cols)));
  };
  if ($('[data-grid]')) applyCols(String(store.get('dna-view', '4')));
  $$('.views button').forEach((b) => b.addEventListener('click', () => { store.set('dna-view', b.dataset.cols); applyCols(b.dataset.cols); }));

  // Filter & Sort panel: opens from the toolbar, applies on submit, drops empty fields from the URL
  const fDrawer = $('[data-filter-drawer]');
  if (fDrawer) {
    const fForm = $('[data-filter-drawer-form]', fDrawer);
    const open = () => { fDrawer.hidden = false; document.body.style.overflow = 'hidden'; $('.drawer__close', fDrawer).focus(); };
    const close = () => { fDrawer.hidden = true; document.body.style.overflow = ''; };
    $$('[data-filter-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-filter-close]', fDrawer).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !fDrawer.hidden) close(); });
    // Desktop (1100px+): the panel sits on the left, always open, and applies on every change
    const wide = matchMedia('(min-width: 1100px)');
    const place = () => { fDrawer.hidden = !wide.matches; if (wide.matches) document.body.style.overflow = ''; };
    wide.addEventListener('change', place); place();
    fForm.addEventListener('change', (e) => { if (wide.matches && !e.target.matches('input[type="number"]')) fForm.requestSubmit(); });
    fForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams(new FormData(fForm));
      for (const [k, v] of [...params]) if (v === '') params.delete(k);
      window.location.href = `${fForm.action}${params.toString() ? `?${params}` : ''}`;
    });
  }

  // Filters and sort apply as soon as they change (they live in the URL, so Back keeps them)
  const filterForm = $('[data-filter-form]');
  filterForm?.addEventListener('change', (e) => {
    if (e.target.matches('input[type="number"]')) return;
    const params = new URLSearchParams(new FormData(filterForm));
    for (const [k, v] of [...params]) if (v === '') params.delete(k);
    window.location.search = params.toString();
  });
  filterForm?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('input[type="number"]')) { e.preventDefault(); filterForm.dispatchEvent(new Event('change')); }
  });

  // Load more without leaving the page
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    more.textContent = 'Loading…';
    try {
      const html = await (await fetch(more.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-products]');
      $$('[data-products] > *', doc).forEach((card) => grid.appendChild(document.importNode(card, true)));
      const next = $('[data-load-more]', doc);
      const wrap = more.closest('.more');
      if (next) { more.href = next.href; more.textContent = 'Load more'; wrap.querySelector('p').replaceWith(document.importNode($('.more p', doc), true)); }
      else wrap.remove();
      try { const k = 'dna-more:' + location.pathname + location.search; const st = JSON.parse(sessionStorage.getItem(k) || '{}'); st.pages = (st.pages || 1) + 1; sessionStorage.setItem(k, JSON.stringify(st)); } catch (err) {}
      syncHearts();
    } catch { window.location.href = more.href; }
  });

  // Saved pieces (wishlist), kept in this browser
  const getSaved = () => store.get('dna-saved', []);
  const syncHearts = () => {
    const saved = getSaved();
    $$('[data-heart]').forEach((h) => {
      const on = saved.includes(h.dataset.heart);
      h.setAttribute('aria-pressed', String(on));
      h.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + h.getAttribute('aria-label').replace(/^(Save|Remove) /, ''));
    });
    $$('[data-saved-count]').forEach((c) => { c.textContent = saved.length; });
  };
  document.addEventListener('click', (e) => {
    const h = e.target.closest('[data-heart]');
    if (!h) return;
    e.preventDefault();
    const saved = getSaved();
    const i = saved.indexOf(h.dataset.heart);
    if (i > -1) saved.splice(i, 1); else saved.unshift(h.dataset.heart);
    store.set('dna-saved', saved.slice(0, 60));
    syncHearts();
    if (i > -1) h.closest('[data-saved-grid] .product')?.remove();
  });
  syncHearts();

  const savedGrid = $('[data-saved-grid]');
  if (savedGrid) {
    const handles = getSaved();
    $('[data-saved-empty]').hidden = handles.length > 0;
    const money = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    Promise.all(handles.map((h) => fetch(`${routes.root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((products) => {
        products.filter(Boolean).forEach((p) => {
          const el = document.createElement('article');
          el.className = 'product' + (p.available ? '' : ' is-sold');
          const img = p.featured_image ? `<img src="${p.featured_image}&width=720" alt="" loading="lazy">` : '';
          el.innerHTML = `<a class="product__img" href="${p.url}">${img}${p.available ? '' : '<span class="stamp">Sold</span>'}</a>
            <button class="heart" type="button" data-heart="${p.handle}" aria-pressed="true" aria-label="Remove ${p.title.replace(/"/g, '&quot;')}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.4l2.65 5.4 5.95.86-4.3 4.2 1.02 5.92L12 16.98l-5.32 2.8 1.02-5.92-4.3-4.2 5.95-.86z"/></svg></button>
            <a class="product__name" href="${p.url}"></a><p class="product__price">${money(p.price)}</p>`;
          el.querySelector('.product__name').textContent = p.title;
          savedGrid.appendChild(el);
        });
      });
  }

  // Bag drawer
  const drawerEl = () => $('[data-cart-drawer]');
  let lastFocus = null;
  const openCart = () => {
    const d = drawerEl(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false; document.body.classList.add('is-locked');
    $('.drawer__close', d)?.focus();
    return true;
  };
  const closeCart = () => {
    const d = drawerEl(); if (!d) return;
    d.hidden = true; document.body.classList.remove('is-locked');
    lastFocus?.focus();
  };
  const refreshCart = async (open) => {
    const res = await fetch(`${routes.root}?sections=cart-drawer`);
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', doc);
    const wasOpen = !drawerEl().hidden;
    const keep = $('.drawer__body', drawerEl())?.scrollTop || 0;
    drawerEl().replaceWith(fresh);
    const body = $('.drawer__body', fresh); if (body) body.scrollTop = keep;
    fresh.hidden = !(open || wasOpen);
    const count = (fresh.querySelector('#drawer-title')?.textContent.match(/\d+/) || ['0'])[0];
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; });
    if (open) $('.drawer__close', fresh)?.focus();
  };
  const cartPost = async (url, body) => {
    const d = drawerEl(); d?.classList.add('is-busy');
    try {
      const res = await fetch(`${url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not update the bag');
      return json;
    } finally { drawerEl()?.classList.remove('is-busy'); }
  };

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-open-cart]')) { if (openCart()) e.preventDefault(); return; }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
    const change = e.target.closest('[data-line][data-qty]');
    if (change) {
      try { await cartPost(routes.cartChange, { line: Number(change.dataset.line), quantity: Number(change.dataset.qty) }); } catch (err) { alertInline(change, err.message); }
      await refreshCart(true);
      return;
    }
    const add = e.target.closest('[data-add]');
    if (add) {
      try { await cartPost(routes.cartAdd, { items: [{ id: Number(add.dataset.add), quantity: 1 }] }); } catch (err) { alertInline(add, err.message); }
      await refreshCart(true);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawerEl() && !drawerEl().hidden) closeCart(); });

  const alertInline = (el, msg) => {
    let p = el.parentElement.querySelector('.form-error');
    if (!p) { p = document.createElement('p'); p.className = 'form-error red small'; p.setAttribute('role', 'alert'); el.parentElement.appendChild(p); }
    p.textContent = msg;
  };

  // Product form: add to bag without leaving the page
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!drawerEl()) return;
      e.preventDefault();
      const btn = $('[data-add-button]', form);
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        await cartPost(routes.cartAdd, { items: [{ id: Number($('[data-variant-id]', form).value), quantity: 1 }] });
        await refreshCart(true);
      } catch (err) { alertInline(btn, err.message); }
      btn.disabled = false; btn.textContent = label;
    });

    // Variant picker
    const json = $('[data-variants]', form);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const money = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const picked = [1, 2, 3].map((n) => $(`[data-option="${n}"]:checked`, form)?.value).filter(Boolean);
      const v = variants.find((x) => picked.every((val, i) => x.options[i] === val));
      const btn = $('[data-add-button]', form);
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', form).value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? `Add to bag, ${money(v.price)}` : 'Sold';
      const price = $('[data-price]');
      if (price) price.innerHTML = v.compare_at_price > v.price ? `<span class="price--sale">${money(v.price)}</span> <s>${money(v.compare_at_price)}</s>` : money(v.price);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    });
  });

  // Product gallery: thumbnails, arrows, swipe and arrow keys
  const gMain = $('[data-main-media]');
  const gItems = gMain ? $$('[data-media]', gMain) : [];
  const gShow = (i) => {
    if (!gItems.length) return;
    const n = (i + gItems.length) % gItems.length;
    gItems.forEach((m, k) => m.classList.toggle('is-active', k === n));
    const id = gItems[n].dataset.media;
    $$('[data-thumb]').forEach((x) => x.setAttribute('aria-current', String(x.dataset.thumb === id)));
    gItems.forEach((m, k) => { if (k !== n) m.querySelector('video')?.pause(); });
  };
  const gIndex = () => Math.max(0, gItems.findIndex((m) => m.classList.contains('is-active')));
  $$('[data-thumb]').forEach((t) => t.addEventListener('click', () => gShow(gItems.findIndex((m) => m.dataset.media === t.dataset.thumb))));
  if (gItems.length > 1) {
    // Fetch the other photos once the page is ready, so switching is instant
    const warm = () => gItems.forEach((m) => m.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; }));
    if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', () => setTimeout(warm, 300), { once: true });
    gMain.classList.add('has-arrows');
    gMain.insertAdjacentHTML('beforeend', '<button class="slides__arrow slides__arrow--prev" type="button" data-g="-1" aria-label="Previous photo">‹</button><button class="slides__arrow slides__arrow--next" type="button" data-g="1" aria-label="Next photo">›</button>');
    $$('[data-g]', gMain).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); gShow(gIndex() + Number(b.dataset.g)); }));
    let x0 = null, y0 = null;
    gMain.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    gMain.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) gShow(gIndex() + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
    document.addEventListener('keydown', (e) => {
      if (e.target.closest('input, textarea, select') || document.querySelector('[data-cart-drawer]:not([hidden])')) return;
      if (e.key === 'ArrowRight') gShow(gIndex() + 1);
      if (e.key === 'ArrowLeft') gShow(gIndex() - 1);
    });
  }

  // Complete the look
  const look = $('[data-look]');
  if (look) {
    const items = $$('[data-look-item]', look);
    const tiers = (($('[data-tiers]', look) || {}).dataset?.tiers || '').split(',').map(Number).filter((n) => !isNaN(n));
    const money = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    $('[data-look-max]', look).textContent = items.length;
    const priceOf = (sel) => Number(sel.tagName === 'SELECT' ? sel.selectedOptions[0].dataset.price : sel.dataset.price);
    const update = () => {
      const picked = items.filter((i) => $('[data-look-check]', i).checked);
      const sum = picked.reduce((s, i) => s + priceOf($('[data-look-variant]', i)), 0);
      const pct = picked.length ? (tiers[Math.min(picked.length, tiers.length) - 1] || 0) : 0;
      const save = Math.round(sum * pct / 100);
      $('[data-look-count]', look).textContent = picked.length;
      $('[data-look-total]', look).textContent = money(sum - save);
      const row = $('[data-look-savings-row]', look);
      row.hidden = !save; $('[data-look-savings]', look).textContent = `−${money(save)}`;
      $$('.tiers li', look).forEach((li, i) => li.classList.toggle('is-on', i === picked.length - 1));
      const btn = $('[data-look-add]', look);
      btn.disabled = picked.length === 0;
      btn.textContent = picked.length ? `Add the look, ${money(sum - save)}` : 'Add the look';
    };
    look.addEventListener('change', update);
    $('[data-look-add]', look).addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const ids = items.filter((i) => $('[data-look-check]', i).checked).map((i) => ({ id: Number($('[data-look-variant]', i).value), quantity: 1 }));
      btn.disabled = true;
      try { await cartPost(routes.cartAdd, { items: ids }); await refreshCart(true); } catch (err) { alertInline(btn, err.message); }
      update();
    });
    update();
  }
})();

{
// Drop page countdown. Hidden until data-drop holds a date.
const count = document.querySelector('.count[data-drop]');
const dropAt = count && Date.parse(count.dataset.drop);
if (dropAt) {
  count.hidden = false;
  const pad = (n) => String(n).padStart(2, '0');
  const set = (sel, n) => { count.querySelector(sel).firstChild.nodeValue = pad(n); };
  const tick = () => {
    const left = Math.max(0, dropAt - Date.now()) / 1000;
    set('[data-d]', Math.floor(left / 86400));
    set('[data-h]', Math.floor(left / 3600) % 24);
    set('[data-m]', Math.floor(left / 60) % 60);
    set('[data-s]', Math.floor(left) % 60);
    if (left <= 0) location.reload();
  };
  tick();
  setInterval(tick, 1000);
}
}

// ---------- Gallery ----------
(() => {
  const grid = document.querySelector('[data-gallery]');
  if (!grid) return;
  const items = [...grid.querySelectorAll('.gallery__item')];
  document.querySelectorAll('[data-kind-filter]').forEach((b) => b.addEventListener('click', () => {
    const k = b.dataset.kindFilter;
    document.querySelectorAll('[data-kind-filter]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
    items.forEach((f) => { f.hidden = k !== 'all' && f.dataset.kind !== k; });
  }));
  const lb = document.querySelector('[data-lightbox]');
  if (!lb || !lb.showModal) return;
  const img = lb.querySelector('img'), cap = lb.querySelector('.lightbox__cap');
  let at = 0;
  const visible = () => items.filter((f) => !f.hidden);
  const show = (n) => {
    const list = visible();
    at = (n + list.length) % list.length;
    const src = list[at].querySelector('img');
    img.src = src.dataset.full; img.alt = src.alt; cap.textContent = src.alt;
  };
  grid.addEventListener('click', (e) => {
    const b = e.target.closest('[data-shot]');
    if (!b) return;
    show(visible().indexOf(b.closest('.gallery__item')));
    lb.showModal();
  });
  lb.addEventListener('click', (e) => {
    const b = e.target.closest('[data-lb]');
    if (b) b.dataset.lb === 'close' ? lb.close() : show(at + Number(b.dataset.lb));
    else if (e.target === lb) lb.close();
  });
  lb.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') show(at + 1);
    if (e.key === 'ArrowLeft') show(at - 1);
  });
})();

// ---------- Cookie consent: Shopify Customer Privacy API ----------
(() => {
  const box = document.querySelector('[data-consent]');
  if (!box || !window.Shopify?.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
    const cp = window.Shopify.customerPrivacy;
    if (err || !cp) return;
    const c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
    const undecided = !c || ['analytics', 'marketing'].every((k) => !c[k]);
    const required = cp.shouldShowBanner && cp.shouldShowBanner();
    if (!required && !(window.dna && dna.consentEveryone && undecided)) return;
    const main = box.querySelector('[data-consent-main]'), form = box.querySelector('[data-consent-form]');
    const done = (c) => cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: true, sale_of_data: c.marketing }, () => {
      box.hidden = true; document.documentElement.classList.remove('has-consent');
      document.dispatchEvent(new Event('dna:consent-done'));
    });
    box.hidden = false;
    document.documentElement.classList.add('has-consent');
    box.querySelectorAll('[data-consent-accept]').forEach((b) => b.addEventListener('click', () => done({ analytics: true, marketing: true })));
    box.querySelector('[data-consent-prefs]').addEventListener('click', () => { main.hidden = true; form.hidden = false; });
    form.addEventListener('submit', (e) => { e.preventDefault(); done({ analytics: form.analytics.checked, marketing: form.marketing.checked }); });
  });
})();

// ---------- Home hero: denim shots crossfade ----------
document.querySelectorAll('[data-slides]').forEach((box) => {
  const imgs = [...box.querySelectorAll('.slides__img')];
  if (imgs.length < 2) return;
  const split = box.closest('.split');
  const label = split?.querySelector('[data-slide-label]'), link = split?.querySelector('[data-slide-link]'), line = split?.querySelector('[data-slide-line]');
  const every = Number(box.dataset.interval) || 5000;
  const load = (img) => { if (img.dataset.src) { img.srcset = img.dataset.srcset; img.src = img.dataset.src; delete img.dataset.src; } };
  let at = 0, timer;
  // Slim position bars (shown on phones) so the tap zones make sense
  const bars = document.createElement('div'); bars.className = 'slides__bars'; bars.setAttribute('aria-hidden', 'true');
  bars.innerHTML = imgs.map(() => '<span></span>').join(''); box.appendChild(bars);
  const show = (i) => {
    at = (i + imgs.length) % imgs.length;
    [...bars.children].forEach((b, k) => b.classList.toggle('is-on', k === at));
    load(imgs[(at + 1) % imgs.length]); load(imgs[(at - 1 + imgs.length) % imgs.length]);
    imgs.forEach((img, k) => img.classList.toggle('is-on', k === at));
    // Colour side follows the photo: brand-kit cream, slate blue, red, brown
    const tones = (box.dataset.tones || '').split(',').map((t) => t.trim()).filter((t) => /^[0-3]$/.test(t));
    split?.setAttribute('data-tone', tones.length ? tones[at % tones.length] : String(at % 4));
    const cur = imgs[at];
    if (label && cur.dataset.label) label.textContent = cur.dataset.label;
    if (link && cur.dataset.href) { link.href = cur.dataset.href; if (link !== label) link.textContent = cur.dataset.btn || 'Shop'; }
    if (line) { line.textContent = cur.dataset.btn || ''; line.hidden = !cur.dataset.btn; }
  };
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const play = () => { if (!reduce) { clearInterval(timer); timer = setInterval(() => show(at + 1), every); } };
  if (split?.classList.contains('split--hero')) window.addEventListener('load', () => load(imgs[1]));
  else new IntersectionObserver((e, o) => { if (e[0].isIntersecting) { load(imgs[1]); o.disconnect(); } }).observe(box);
  box.addEventListener('mouseenter', () => clearInterval(timer));
  box.addEventListener('mouseleave', play);
  box.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-slide]');
    if (arrow) { show(at + Number(arrow.dataset.slide)); play(); return; }
    // Phones: tap the left or right edge to change slide, anywhere else opens it
    if (matchMedia('(max-width: 960px)').matches) {
      const r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width;
      if (x < 0.22) { show(at - 1); play(); return; }
      if (x > 0.78) { show(at + 1); play(); return; }
    }
    if (imgs[at].dataset.href) { location.href = imgs[at].dataset.href; return; }
    show(at + 1); play();
  });
  // Swipe on phones
  let x0 = null;
  box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; clearInterval(timer); }, { passive: true });
  box.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) { show(at + (dx < 0 ? 1 : -1)); e.preventDefault(); }
    play();
  });
  document.addEventListener('visibilitychange', () => (document.hidden ? clearInterval(timer) : play()));
  play();
});

// ---------- Shop the look: light up the dot and its product together ----------
document.querySelectorAll('[data-look]').forEach((look) => {
  const light = (n) => look.querySelectorAll('[data-n]').forEach((el) => el.classList.toggle('is-on', el.dataset.n === n));
  look.addEventListener('mouseover', (e) => { const el = e.target.closest('[data-n]'); if (el) light(el.dataset.n); });
  look.addEventListener('mouseleave', () => light(''));
  look.addEventListener('click', (e) => {
    const dot = e.target.closest('.look__dot');
    if (!dot) return;
    light(dot.dataset.n);
    const row = look.querySelector(`li[data-n="${dot.dataset.n}"]`);
    if (row && matchMedia('(max-width: 960px)').matches) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});

// ---------- Lookbook chapters: intro line, and open the tab named in the URL (#western) ----------
(() => {
  const tabs = [...document.querySelectorAll('[data-kind-filter]')];
  if (!tabs.length) return;
  const intro = document.querySelector('[data-chapter-intro]');
  tabs.forEach((b) => b.addEventListener('click', () => {
    if (intro) intro.textContent = b.dataset.intro || '';
    const k = b.dataset.kindFilter;
    history.replaceState(null, '', k === 'all' ? location.pathname + location.search : `#${k}`);
  }));
  const want = location.hash.slice(1);
  const btn = want && tabs.find((b) => b.dataset.kindFilter === want);
  if (btn) btn.click();
})();

// ---------- 404: show one of the photos at random ----------
(() => {
  const box = document.querySelector('[data-random-photo]');
  if (!box) return;
  const imgs = [...box.querySelectorAll(':scope > img')];
  if (!imgs.length) return;
  const keep = imgs[Math.floor(Math.random() * imgs.length)];
  imgs.forEach((img) => { if (img !== keep) img.remove(); });
  keep.hidden = false;
  // Fill the screen below the header, whatever the bar is doing
  const fit = () => { box.style.minHeight = Math.max(420, innerHeight - (box.getBoundingClientRect().top + scrollY)) + 'px'; };
  fit(); addEventListener('resize', fit); document.addEventListener('click', () => setTimeout(fit, 50));
})();

// ---------- Announcement bar: close, and keep it closed until the message changes ----------
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bar-close]');
  if (!btn) return;
  const bar = btn.closest('[data-bar]');
  try { localStorage.setItem('dna-bar', bar.dataset.bar); } catch {}
  document.documentElement.classList.add('bar-closed');
});

// ---------- 10% signup popup: shows the code right after joining ----------
// Once (12s or half a page of scrolling), never over the cookie banner. Closing leaves a small "10% off" tab
// bottom-left; hiding the tab keeps it away 14 days. After joining it never shows again.
(() => {
  const box = document.querySelector('[data-popup]');
  if (!box) return;
  const tab = document.querySelector('[data-spin-tab]');
  if (['cart', 'privacy', 'terms', 'refunds', 'drop'].includes(document.body.dataset.page)) return;
  const get = () => { try { return JSON.parse(localStorage.getItem('dna-popup')) || {}; } catch { return {}; } };
  const put = (v) => { try { localStorage.setItem('dna-popup', JSON.stringify({ ...get(), ...v })); } catch {} };
  const st = get();
  if (st.joined || (st.hidden && Date.now() - st.hidden < 14 * 864e5)) return;
  const show = () => {
    if (document.documentElement.classList.contains('has-consent')) return setTimeout(show, 4000);
    tab.hidden = true; box.hidden = false; document.documentElement.classList.add('has-popup');
    box.querySelector('input[type=email]').focus({ preventScroll: true });
  };
  const close = () => {
    box.hidden = true; document.documentElement.classList.remove('has-popup');
    if (!get().joined) { tab.hidden = false; put({ closed: Date.now() }); }
  };
  if (st.closed) tab.hidden = false;
  else {
    // Right after the visitor answers the cookie banner; if there's no banner, 5s in.
    let fired = false;
    const once = (ms) => { if (!fired) { fired = true; setTimeout(show, ms); } };
    document.addEventListener('dna:consent-done', () => once(1200), { once: true });
    setTimeout(() => { if (!document.documentElement.classList.contains('has-consent')) once(0); }, 5000);
  }
  tab.addEventListener('click', (e) => {
    if (e.target.closest('[data-spin-tab-close]')) { tab.hidden = true; put({ hidden: Date.now() }); return; }
    show();
  });
  box.addEventListener('click', (e) => { if (e.target.closest('[data-popup-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !box.hidden) close(); });
  const form = box.querySelector('[data-popup-form]');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    fetch(form.action, { method: 'POST', mode: 'no-cors', body: new FormData(form) }).catch(() => {});
    put({ joined: true });
    form.querySelector('[data-step="1"]').hidden = true;
    const s2 = form.querySelector('[data-step="2"]'); s2.hidden = false;
    s2.querySelector('[data-code]').textContent = box.dataset.code;
  });
  box.querySelector('[data-copy]').addEventListener('click', (e) => {
    navigator.clipboard?.writeText(box.dataset.code);
    e.target.textContent = 'Copied';
  });
})();

// ---------- Announcement bar: rotate messages every 5s ----------
(() => {
  const bar = document.querySelector('[data-bar-rotate]');
  if (!bar) return;
  const msgs = [...bar.querySelectorAll('p')];
  if (msgs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let at = 0, t;
  const go = () => { msgs[at].classList.remove('is-on'); at = (at + 1) % msgs.length; msgs[at].classList.add('is-on'); };
  const play = () => { clearInterval(t); t = setInterval(go, 5000); };
  bar.addEventListener('mouseenter', () => clearInterval(t));
  bar.addEventListener('mouseleave', play);
  play();
})();

// ---------- Event promo: hides itself once the day has passed ----------
document.querySelectorAll('[data-event-date]').forEach((box) => {
  const [y, m, d] = box.dataset.eventDate.split('-').map(Number);
  const day = new Date(y, m - 1, d), today = new Date(); today.setHours(0, 0, 0, 0);
  const n = Math.round((day - today) / 864e5);
  if (n < 0) { box.hidden = true; return; }
});

// ---------- Home bands: tap anywhere on the photo to open its collection ----------
document.querySelectorAll('.hero--link').forEach((band) => {
  const a = band.querySelector('h2 a');
  if (!a) return;
  band.style.cursor = 'pointer';
  band.addEventListener('click', (e) => { if (!e.target.closest('a')) location.href = a.href; });
});

// ---------- Shop dropdown (Men's / Women's) ----------
document.querySelectorAll('[data-drop]').forEach((drop) => {
  const btn = drop.querySelector('.nav__caret');
  const set = (open) => { drop.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open); };
  btn.addEventListener('click', (e) => { e.stopPropagation(); set(!drop.classList.contains('is-open')); });
  if (matchMedia('(hover: hover) and (min-width: 961px)').matches) {
    drop.addEventListener('mouseenter', () => set(true));
    drop.addEventListener('mouseleave', () => set(false));
  }
  document.addEventListener('click', (e) => { if (!drop.contains(e.target)) set(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
});

// ---------- Below-the-fold videos: only download and play when on screen ----------
(() => {
  const vids = [...document.querySelectorAll('.event-promo__header video, .past-event__media video')];
  if (!vids.length) return;
  const play = (v) => { if (v.preload !== 'auto') { v.preload = 'auto'; } const p = v.play(); if (p && p.catch) p.catch(() => {}); };
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) play(e.target); else e.target.pause(); }), { rootMargin: '200px 0px' });
  vids.forEach((v) => { v.muted = true; io.observe(v); });
})();

// ---------- Event header video: skip the close-up intro, loop from 3s ----------
document.querySelectorAll('.event-promo__header video').forEach((v) => {
  const START = 3;
  v.loop = false;
  const jump = () => { try { v.currentTime = START; } catch (e) {} };
  if (v.readyState >= 1) jump(); else v.addEventListener('loadedmetadata', jump, { once: true });
  v.addEventListener('ended', () => { jump(); v.play(); });
});


// Policy pages: build the "On this page" side menu from the policy's headings, like the preview site.
(() => {
  const body = document.querySelector('.shopify-policy__body');
  if (!body) return;
  const hs = [...body.querySelectorAll('h2')];
  const nav = document.createElement('nav');
  nav.className = 'aside';
  nav.setAttribute('aria-label', 'On this page');
  hs.forEach((h, i) => {
    if (!h.id) h.id = (h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40)) || 'section-' + i;
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    nav.append(a);
  });
  if (hs.length) nav.insertAdjacentHTML('beforeend', '<span class="aside__rule"></span>');
  [['/policies/privacy-policy', 'Privacy'], ['/policies/terms-of-service', 'Terms'], ['/policies/refund-policy', 'Refunds']].forEach(([href, label]) => {
    const a = document.createElement('a');
    a.href = href;
    a.textContent = label;
    if (location.pathname.endsWith(href)) a.setAttribute('aria-current', 'page');
    nav.append(a);
  });
  const wrap = document.createElement('div');
  wrap.className = 'aside-layout legal';
  body.before(wrap);
  wrap.append(nav, body);
  body.classList.add('legal__body');
  body.closest('.shopify-policy__container')?.classList.add('has-aside');
})();


// ---------- Collections: coming back from a product returns to the same spot ----------
(() => {
  const grid = document.querySelector('[data-products]');
  if (!grid) return;
  const key = 'dna-more:' + location.pathname + location.search;
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (e) { return {}; } };
  const write = (st) => { try { sessionStorage.setItem(key, JSON.stringify(st)); } catch (e) {} };
  const save = () => { const st = read(); st.y = window.scrollY; write(st); };
  document.addEventListener('click', (e) => { if (e.target.closest('[data-products] a')) save(); }, true);
  window.addEventListener('pagehide', save);
  const nav = performance.getEntriesByType('navigation')[0];
  const st = read();
  if (!nav || nav.type !== 'back_forward' || !st.y) { if (nav && nav.type !== 'back_forward') write({}); return; }
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const restore = async () => {
    let more = document.querySelector('[data-load-more]');
    for (let i = 1; i < (st.pages || 1) && more; i++) {
      try {
        const html = await (await fetch(more.href)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-products] > *').forEach((card) => grid.appendChild(document.importNode(card, true)));
        const next = doc.querySelector('[data-load-more]');
        const wrap = more.closest('.more');
        if (next) { more.href = next.href; const p = doc.querySelector('.more p'); if (p) wrap.querySelector('p').replaceWith(document.importNode(p, true)); }
        else { wrap.remove(); more = null; }
      } catch (e) { break; }
    }
    window.scrollTo(0, st.y);
  };
  restore();
})();

// ---------- Product page: hover zoom follows the cursor (desktop mouse only) ----------
(() => {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('.pdp__media > a').forEach((a) => {
    const img = a.querySelector('img');
    if (!img) return;
    const move = (e) => {
      const r = a.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    };
    a.addEventListener('mouseenter', (e) => { move(e); a.classList.add('is-zoom'); });
    a.addEventListener('mousemove', move);
    a.addEventListener('mouseleave', () => { a.classList.remove('is-zoom'); img.style.transformOrigin = '50% 50%'; });
  });
})();
